var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 20.7733C9.75 22.0031 10.7294 23 11.9375 23C13.1456 23 14.125 22.0031 14.125 20.7733M1 9.01619C1 7.23482 1.7 3.13765 4.5 1M22 9.01619C22 7.23482 21.3 3.13765 18.5 1M1.875 17.9231H21.125L18.0348 13.2047C17.7676 12.7967 17.625 12.3173 17.625 11.8268V8.12551C17.625 4.68211 14.8827 1.89069 11.5 1.89069C8.11726 1.89069 5.375 4.68211 5.375 8.12551V11.8268C5.375 12.3173 5.23239 12.7967 4.96515 13.2047L1.875 17.9231Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.2d47b9f1d8e19144607adb567da50daa.svg";
export { ForwardRef as ReactComponent };